export default (id) => {
  const content = loadTemplate('template_options_footer')
    .replace(/{id}/g, id)
    .replace(/{amount}/g, `amount_${id}`);// eslint-disable-line i18next/no-literal-string

  global.$('#pnl_footer').html(content);
};
